import { Flex } from '@grupoboticario/flora-react';
import { CrossIcon, ArrowLeftIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';

import Styles from '../Drawers.styles';

import type { THeaderContent } from './Drawers.components.d';

export const HeaderContent = ({ title, isToBack, onCloseCallback, ...props }: THeaderContent) => {
  return (
    <Flex align='center' justify='flexstart' gap='$4'>
      <Styles.DrawerCloseButton
        aria-label={`Fechar ${title}`}
        role='link'
        asChild
        onClick={onCloseCallback}
        {...props}
      >
        {isToBack ? <ArrowLeftIcon aria-label='voltar' /> : <CrossIcon aria-label='fechar' />}
      </Styles.DrawerCloseButton>
      <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold' as='h1'>
        {title}
      </ResponsiveFloraTypography>
    </Flex>
  );
};
